'use strict';

var ValidateAndApplyPropertyDescriptor = require('./ValidateAndApplyPropertyDescriptor');

// https://262.ecma-international.org/6.0/#sec-iscompatiblepropertydescriptor

module.exports = function IsCompatiblePropertyDescriptor(Extensible, Desc, Current) {
	return ValidateAndApplyPropertyDescriptor(undefined, undefined, Extensible, Desc, Current);
};



//////////////////
// WEBPACK FOOTER
// ./~/es-abstract/2015/IsCompatiblePropertyDescriptor.js
// module id = 783
// module chunks = 231608221292675